import { environment } from '../../environments/environment';

// Build-time production flag wins over hostname (so a prod-built UI served from
// localhost via the BFF still authenticates against the prod Entra app).
export function determineMSALScope(): string {
  if (environment.production) {
    return 'api://FCDSTCVV/Api.Access';
  }

  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname.includes('ams1907.com')) {
    return 'api://cvv/Api.Access';
  }
  if (hostname.includes('ups.com')) {
    return 'api://FCDSTCVV/Api.Access';
  }
  return 'api://cvv/Api.Access';
}

export function determineMSALConfigFile(): string {
  if (environment.production) {
    return '/assets/msal-config.production.json';
  }

  const hostname = window.location.hostname;
  if (hostname === 'localhost') {
    return '/assets/msal-config.json';
  }
  if (hostname.includes('ams1907.com')) {
    return '/assets/msal-config.development.json';
  }
  if (hostname.includes('ups.com')) {
    return '/assets/msal-config.production.json';
  }
  return '/assets/msal-config.openshift.json';
}
